import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import ClientLogoCarousel from './components/ClientLogoCarousel';
import ProjectShowcase from './components/ProjectShowcase';
import TestimonialSection from './components/TestimonialSection';
import SkillsVisualization from './components/SkillsVisualization';
import BlogPreview from './components/BlogPreview';
import CTASection from './components/CTASection';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Mr Mike Technologies - Production-Ready Full-Stack Developer | React, Node.js Expert</title>
        <meta 
          name="description" 
          content="Senior Full-Stack Engineer specializing in scalable web applications. 8+ years building production-grade solutions for startups and enterprises. React, Node.js, AWS expert at Mr Mike Technologies." 
        />
        <meta 
          name="keywords" 
          content="Mr Mike Technologies, full-stack developer, React developer, Node.js expert, web application development, scalable solutions, startup CTO, technical consultant" 
        />
        <meta property="og:title" content="Mr Mike Technologies - Production-Ready Full-Stack Developer" />
        <meta 
          property="og:description" 
          content="Senior Full-Stack Engineer building scalable solutions for growth-stage startups and enterprise clients at Mr Mike Technologies." 
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://mikedev.pro/homepage" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* --- Promo Section: Modern & Professional --- */}
          <section className="relative flex flex-col md:flex-row items-center justify-center gap-8 my-12 py-12 px-4 md:px-16 rounded-3xl overflow-hidden bg-gradient-to-r from-blue-900/80 via-blue-800/70 to-slate-900/80 shadow-2xl">
            {/* Image */}
            <div className="flex-shrink-0 w-full md:w-1/2 flex justify-center">
              <img
                src="/assets/images/my-pic3.png"
                alt="Mr Mike Technologies - Software Developer Promo"
                className="rounded-2xl shadow-2xl max-w-xs md:max-w-md border-4 border-blue-700"
              />
            </div>
            {/* Text Content */}
            <div className="flex flex-col items-center md:items-start text-center md:text-left w-full md:w-1/2">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 drop-shadow-lg">
                Unlock Your Digital Potential
              </h2>
              <p className="text-lg md:text-xl text-blue-100 mb-6 max-w-xl">
                Work with <span className="font-bold text-primary">Mr Mike Technologies</span> – a results-driven Software Developer specializing in scalable web & mobile solutions, cloud deployments, and technical mentorship.
              </p>
              <ul className="text-blue-200 text-base md:text-lg mb-6 space-y-2">
                <li>• Web & Mobile Development</li>
                <li>• Database Design & Optimization</li>
                <li>• Cloud Deployments & DEVOPS</li>
                <li>• Custom Software Solutions</li>
              </ul>
              <a
                href="#contact"
                className="inline-block bg-primary hover:bg-primary/80 text-white font-semibold px-8 py-3 rounded-xl shadow-lg transition-all duration-200"
              >
                Get Started Today
              </a>
            </div>
            {/* Optional: Decorative background shapes */}
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute -top-10 -left-10 w-40 h-40 bg-blue-700/30 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-10 -right-10 w-56 h-56 bg-primary/20 rounded-full blur-3xl"></div>
            </div>
          </section>
          {/* --- End Promo Section --- */}

          <HeroSection />

          <ClientLogoCarousel />
          <ProjectShowcase />
          <SkillsVisualization />
          <TestimonialSection />
          <BlogPreview />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;